import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconMenuSvg } from "./IconMenuSvg.mjs";
const IconMenu = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconMenuSvg, ...iconProps });
};
export {
  IconMenu
};
